import type { ReactNode } from "react";

/**
 * Inline SVG flags: emoji flags render as plain letters on Windows, which is a poor fit for a
 * Windows-style UI. Add a language here to make it selectable in the navbar.
 */
const TR = (
  <svg viewBox="0 0 30 20" aria-hidden focusable="false">
    <rect width="30" height="20" fill="#E30A17" />
    <circle cx="11" cy="10" r="5" fill="#fff" />
    <circle cx="12.4" cy="10" r="4" fill="#E30A17" />
    <polygon
      fill="#fff"
      points="16.2,10 18.6,9.2 17.1,11.2 17.1,8.8 18.6,10.8"
    />
  </svg>
);

const GB = (
  <svg viewBox="0 0 60 40" aria-hidden focusable="false">
    <rect width="60" height="40" fill="#012169" />
    <path d="M0,0 60,40 M60,0 0,40" stroke="#fff" strokeWidth="8" />
    <path d="M0,0 60,40 M60,0 0,40" stroke="#C8102E" strokeWidth="3" />
    <path d="M30,0v40M0,20h60" stroke="#fff" strokeWidth="13" />
    <path d="M30,0v40M0,20h60" stroke="#C8102E" strokeWidth="8" />
  </svg>
);

export type LanguageOption = { code: string; label: string; flag: ReactNode };

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: "tr", label: "Türkçe", flag: TR },
  { code: "en", label: "English", flag: GB },
];
